/* @flow */
import InstantClick from 'instantclick';
import '../../../vendor/modernizr.custom.js';
import analytics from './analytics';
import collapsibleNav from './collapsibleNav';
import gallery from './gallery';
import langPicker from './langPicker';
import video from './video';
import type {Module} from '../types';

// Initialize app storage object
window.weslife = window.weslife || {};

const modules: Array<Module> = [
  analytics,
  collapsibleNav,
  gallery,
  langPicker,
  video
];

const reloadModules: Function = (): void => {
  modules.forEach((module: Module) => {
    module.init();
    langPicker.onChange(() => {
      analytics.sendPageview();
      gallery.resizeAll();
    });
  });
};

// Load modules on initial page load
reloadModules();

// Reload modules when page changes
InstantClick.on('change', (isInitialLoad: boolean) => {
  if (!isInitialLoad) {
    analytics.sendPageview();
    reloadModules();
  }
});

if (window.weslife.preload) {
  InstantClick.init(50);
} else if (process.env.NODE_ENV === 'development') {
  /* eslint-disable no-console */
  console.info('Page preloading disabled.');
}



// WEBPACK FOOTER //
// ./resources/assets/magazine/js/magazine/index.js